import React, { useCallback, useEffect, useRef } from 'react'
import ProgressTimeout from '../../widgets/ProgressTimeout';
import './AreYouSure.css'

const AreYouSure = ({hideMe, applyMe, actionTitle='Delete'}) => {

  const timeoutDuration = 2500;
  const hideTimerRef = useRef(null);

  const handleHideMe = useCallback(() => {
    clearTimeout(hideTimerRef.current);
    console.log(`AreYouSure: Hiding`);    
    hideMe();
  }, [hideMe]);

  const handleApplyMe = useCallback(() => {
    handleHideMe();
    applyMe();    
  }, [applyMe, handleHideMe]);

  useEffect(()=>{
    clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(() => handleHideMe(), timeoutDuration);

    return () => {
      clearTimeout(hideTimerRef.current);
    }
  }, [handleHideMe]);

  return (
    <div className='areYouSure'>
      <div>Delete?</div>
      <div className='aysCtrl'>
        <div className='aysButton Cancel' onClick={handleHideMe}>
          <div>Cancel</div>
          <ProgressTimeout millis={timeoutDuration}/>
        </div>
        <div className='aysButton Delete' onClick={handleApplyMe}>Yes, {actionTitle}</div>
      </div>
    </div>
  )
}

export default React.memo(AreYouSure);